import { http } from '../plugins/http'
import { type AxiosResponse } from 'axios'

import type PaginatedResponse from '@/types/PaginatedResponse'
import type DataResponse from '@/types/DataResponse'
import type OrderItem from '@/types/OrderItem'

export default class CheckInService {
  async index(event_id: string, page: number, filters: string, per_page: number | undefined = 25): Promise<AxiosResponse<PaginatedResponse<OrderItem>>> {
    return await http.get<PaginatedResponse<OrderItem>>(`/api/v1/office/readings/${event_id}/check-in?page=${page}&${filters}&per_page=${per_page}`)
  }

  async checkIn(event_id: string, id: string): Promise<AxiosResponse<DataResponse<OrderItem>>> {
    return await http.post<DataResponse<OrderItem>>(`/api/v1/office/readings/${event_id}/check-in/${id}`)
  }

  async undoCheckIn(event_id: string, id: string): Promise<AxiosResponse<DataResponse<OrderItem>>> {
    return await http.delete<DataResponse<OrderItem>>(`/api/v1/office/readings/${event_id}/check-in/${id}`)
  }
}
